export const SALES_ROLES = [
  "director",
  "admin",
  "manager",
  "logistics",
  "accountant",
  "lead_installer",
  "junior_manager",
  "designer",
  "worker",
] as const;
export type SalesRole = (typeof SALES_ROLES)[number] | `custom_${string}`;
export const salesRoleChoices = [
  { id: "director", name: "Руководитель" },
  { id: "admin", name: "Админ" },
  { id: "manager", name: "Менеджер по проектам" },
  { id: "logistics", name: "Логист" },
  { id: "accountant", name: "Бухгалтер" },
  { id: "lead_installer", name: "Главный монтажник" },
  { id: "junior_manager", name: "Младший менеджер" },
];
// Legacy employees keep limited access until an explicit role reassignment.
export function effectiveRole(
  user?: { role?: string; administrator?: boolean; id?: unknown } | null,
): string {
  if (user?.administrator) return user.role === "admin" ? "admin" : "director";
  return user?.role ?? "worker";
}
export const isFullAccessRole = (role?: string) =>
  role === "director" || role === "admin";
export const getSalesRoleLabel = (role?: string) =>
  salesRoleChoices.find((c) => c.id === role)?.name ??
  (role === "designer"
    ? "Дизайнер — назначьте новую роль"
    : "Исполнитель — назначьте новую роль");
